import { render, staticRenderFns } from "./mobileMoreScroll.vue?vue&type=template&id=19986918&scoped=true&"
import script from "./mobileMoreScroll.vue?vue&type=script&lang=js&"
export * from "./mobileMoreScroll.vue?vue&type=script&lang=js&"
import style0 from "./mobileMoreScroll.vue?vue&type=style&index=0&id=19986918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19986918",
  null
  
)

export default component.exports